import { useState, useEffect } from "react";
import { useNavigate, useLoaderData, Form, redirect } from "react-router";
import type { Route } from "./+types/login";
import { authClient } from "../utils/auth.client";

export async function loader({ request }: Route.LoaderArgs) {
    // If already authenticated, redirect to organization-list
    // Note: authClient is client-side, so we can't check it here easily 
    // without a cookie. But the prompt says localStorage. 
    // We will handle redirect in useEffect on the client.

    return {
        adminUsername: process.env.ADMIN_USERNAME || "admin",
        adminPassword: process.env.ADMIN_PASSWORD || "admin123",
    };
}

export default function Login() {
    const { adminUsername, adminPassword } = useLoaderData<typeof loader>();
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
        if (authClient.isAuthenticated()) {
            navigate("/organization-list");
        } else {
            setIsChecking(false);
        }
    }, [navigate]);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const username = formData.get("username") as string;
        const password = formData.get("password") as string;

        if (username === adminUsername && password === adminPassword) {
            authClient.saveSession(username);
            navigate("/organization-list");
        } else {
            setError("Invalid username or password");
        }
    };

    if (isChecking) {
        return <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white italic">Checking session...</div>;
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#0f172a] font-sans">
            <div className="w-full max-w-md p-8 space-y-8 bg-[#1e293b] rounded-2xl shadow-2xl border border-white/10 backdrop-blur-sm">
                <div className="text-center">
                    <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400">
                        Raithu
                    </h1>
                    <p className="mt-2 text-slate-400 font-medium">Organization Settings Portal</p>
                </div>

                <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                    <div className="space-y-4">
                        <div>
                            <label htmlFor="username" className="block text-sm font-semibold text-slate-300 mb-1">
                                Username
                            </label>
                            <input
                                id="username"
                                name="username"
                                type="text"
                                required
                                className="block w-full px-4 py-3 bg-[#0f172a] border border-slate-700 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500 transition-all duration-200"
                                placeholder="Enter your username"
                            />
                        </div>
                        <div>
                            <label htmlFor="password" className="block text-sm font-semibold text-slate-300 mb-1">
                                Password
                            </label>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                required
                                className="block w-full px-4 py-3 bg-[#0f172a] border border-slate-700 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500 transition-all duration-200"
                                placeholder="••••••••"
                            />
                        </div>
                    </div>

                    {error && (
                        <div className="p-3 text-sm text-red-400 bg-red-400/10 border border-red-400/20 rounded-lg animate-pulse">
                            {error}
                        </div>
                    )}

                    <div>
                        <button
                            type="submit"
                            className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-bold rounded-xl text-slate-900 bg-gradient-to-r from-emerald-400 to-cyan-400 hover:from-emerald-300 hover:to-cyan-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-all duration-300 transform hover:-translate-y-0.5"
                        >
                            Sign In
                        </button>
                    </div>
                </form>

                {/* <div className="pt-4 text-center">
                    <p className="text-xs text-slate-500 uppercase tracking-widest font-semibold">
                        &copy; 2026 KJBNAgtechPlatform
                    </p>
                </div> */}
            </div>
        </div>
    );
}
